import React, { useEffect } from "react";
import { IAddCategory, ICategoryId } from "../../Category.props";
import { useForm } from "react-hook-form";
import { CancelButton, FormButton } from "../../../../components/Botton/index";
import Loader from "../../../../components/Loader/index";
import useEditCategory from "./useEditCategory";

interface EditCategoryProps extends ICategoryId {
  onEditComplete?: () => void;
}

const EditCategory: React.FC<EditCategoryProps> = ({ educationId, onEditComplete }) => {
  const {
    formData,
    loading,
    handleChange,
    handleSubmit,
    handleCancel,
    iconPreview,
    setIconPreview,
  } = useEditCategory(educationId, onEditComplete);

  const {
    register,
    handleSubmit: useFormSubmit,
    formState: { errors },
    setValue,
    reset
  } = useForm<IAddCategory>();

  useEffect(() => {
    if (formData.category) {
      reset({ category: formData.category });
    }
  }, [formData.category, reset]);

  const fields = [
    { label: "Category", name: "category", type: "text" },
    { label: "Icon", name: "icon", type: "file" },
  ] as const;

  const handleIconChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      setIconPreview(previewUrl);
      formData.icon = file; 
      console.log(file)
    } else {
      setIconPreview(null);
      formData.icon = null;
    }
    handleChange(e);
  };

  const onSubmit = useFormSubmit((data) => {
    const finalData = {
      category: data.category,
      icon: formData.icon
    };

    console.log(finalData) 
    handleSubmit(finalData);
  });

  return (
    <div className="flex flex-col items-center w-full h-screen p-8">
      <div className="bg-white shadow-md rounded-lg pt-6 pb-6 w-full">
        <div className="border-b-2 w-[100%]">
          <h1 className="text-3xl mb-2 text-gray-700 ml-5">Edit Category</h1>
        </div>
        {loading && <Loader />}
        <form onSubmit={onSubmit} className="space-y-6">
          <fieldset className="m-2 rounded border-opacity-60 bg-white">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 m-4">
              {fields.map((field) => (
                <div key={field.name}>
                  <label
                    className="block text-gray-700 text-base font-semibold mb-2"
                    htmlFor={field.name}
                  >
                    {field.label}:
                  </label>
                  <input
                    className="appearance-none border rounded w-full py-2 px-3 text-gray-600 leading-tight focus:outline-none focus:shadow-outline"
                    type={field.type}
                    id={field.name}
                    {...register(field.name, {
                      required: field.name === "category"
                    })}
                    onChange={field.name === "icon" ? handleIconChange : handleChange}
                    value={field.name !== "icon" ? formData[field.name] : ""}
                  />
                  {errors[field.name] && (
                    <span className="text-red-500 text-xs italic">
                      {field.label} field is required
                    </span>
                  )}
                  {field.name === "icon" && iconPreview && (
                    <div className="mt-2">
                      <p className="text-gray-500 text-sm">Preview:</p>
                      <img
                        src={iconPreview}
                        alt="Icon Preview"
                        className="w-20 h-20 object-contain border rounded"
                      />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </fieldset>
          <div className="flex justify-start mt-6 ml-10">
            <FormButton
              className="py-2 px-4 rounded mr-4"
              type="submit"
              children="Update"
            />
            <CancelButton
              className="py-2 px-4 rounded"
              onClick={handleCancel}
              children="Cancel"
              type="button"
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditCategory;